import axios from 'axios'

const service = axios.create({
    baseURL: `${process.env.VUE_APP_BASE_URL}/truckerpath-product`, // api 的 base_url
    timeout: 30000, // request timeout
})

service.interceptors.response.use(
    response => response,
    error => {
        const obj = (error.response && error.response.data) || {}
        obj.status = error.response.status || null
        obj.state_code = obj.state_code || null
        obj.state_message = obj.state_message || obj.message || 'Something went wrong. Please try again'
        return Promise.reject(obj)
    }
)

export const validateDot = async (body) => {
    try {
        const res = await service({
            url: '/northland/insurance/validate/dot',
            method: 'post',
            data: body
        })
        return res?.data || {}
    } catch (error) {
        console.error(error)
        throw error
    }
}
export const getProductInfo = async (type) => {
    try {
        const res = await service({
            url: `/product/info?platform=NORTHLAND_INSURANCE&type=${type}`,
            method: 'get',
        })
        return res?.data?.data || {}
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const calculateTax = async (body) => {
    try {
        const res = await service({
            url: '/northland/insurance/tax/estimate',
            data: body,
            method: 'post'
        })
        return res?.data || {}
    } catch (error) {
        console.error(error)
        throw error
    }
}
export const createAccount = async (body) => {
    try {
        const res = await service({
            url: '/northland/insurance/create/account',
            method: 'post',
            data: body
        })
        return res?.data || {}
    } catch (error) {
        console.error(error)
        throw error
    }
}
export const payment = async (body) => {
    try {
        const res = await service({
            url: '/northland/insurance/payment',
            method: 'post',
            data: body
        })
        return res?.data || {}
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const getPaymentResult = async (body) => {
    try {
        const res = await service({
            url: '/northland/insurance/payment/result',
            method: 'post',
            data: body
        })
        return res?.data || {}
    } catch (error) {
        console.error(error)
        throw error
    }
}
export const createOrder = async (body) => {
    try {
        const res = await service({
            url: '/northland/insurance/create/order',
            method: 'post',
            data: body
        })
        return res?.data || {}
    } catch (error) {
        console.error(error)
        throw error
    }
}
